import { render, staticRenderFns } from "./AccessLevelLabel.vue?vue&type=template&id=6f94da34"
import script from "./AccessLevelLabel.vue?vue&type=script&lang=js"
export * from "./AccessLevelLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports